import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "CustomSelect-placeholder"
}
const _hoisted_4 = ["id", "value"]
const _hoisted_5 = ["selected", "disabled", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSVG = _resolveComponent("InlineSVG")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["CustomSelect", {darkTheme: _ctx.theme === 'dark', hasBorder: _ctx.hasBorder}])
  }, [
    (_ctx.label !== '')
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id,
          class: "CustomSelect-label _subTitle"
        }, _toDisplayString(_ctx.label), 9, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("label", {
      for: _ctx.id,
      class: _normalizeClass(["CustomSelect-container", {'isFocused': _ctx.isFocused, 'playAnimation': _ctx.playAnimation}])
    }, [
      (_ctx.placeholder !== '' && _ctx.modelValue === null)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.placeholder), 1))
        : _createCommentVNode("", true),
      _createElementVNode("select", {
        id: _ctx.id,
        class: "CustomSelect-select",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
        onFocusin: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isFocused = true)),
        onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
        required: "",
        value: _ctx.modelValue
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
          return (_openBlock(), _createElementBlock("option", {
            key: index,
            selected: _ctx.isDefault(item, _ctx.modelValue),
            disabled: !_ctx.itExist(item.value),
            value: item.value
          }, _toDisplayString(item.label), 9, _hoisted_5))
        }), 128))
      ], 40, _hoisted_4),
      _createVNode(_component_InlineSVG, {
        class: "CustomSelect-icon",
        "fill-color": _ctx.theme === 'dark' ? 'white' : 'dark',
        src: require('@a/icons/arrow-bottom.svg')
      }, null, 8, ["fill-color", "src"])
    ], 10, _hoisted_2)
  ], 2))
}